
import { useTranslation } from "react-i18next";
import { Pill } from "../pills";
import { ResizableTable } from "../ResizableTable";

type Cell = 1 | 0 | "own";
const ROLES = ["admin", "manager", "auditor", "supplier", "viewer"] as const;
const OPS: [string, Cell[]][] = [
  ["a_pm1", [1, 0, 0, 0, 0]],
  ["a_pm2", [1, 1, 0, 0, 0]],
  ["a_pm3", [1, 1, 1, 0, 1]],
  ["a_pm4", [1, 1, 0, 0, 0]],
  ["a_pm5", [1, 1, 0, 1, 0]],
  ["a_pm6", [1, 1, "own", 0, 0]],
  ["a_pm7", [1, 1, "own", 0, 0]],
  ["a_pm8", [1, 1, 0, 0, 0]],
  ["a_pm9", [1, 1, "own", 1, 0]],
  ["a_pm10", [1, 0, 0, 1, 0]],
  ["a_pm11", [1, 1, 1, 0, 0]],
  ["a_pm12", [1, 1, 1, "own", 1]],
];

export function PermMatrix() {
  const { t } = useTranslation();
  return (
    <ResizableTable
      size="small"
      pagination={false}
      scroll={{ x: "max-content" }}
      rowKey={(r) => r[0]}
      dataSource={OPS}
      columns={[
        { title: "", render: (_, r) => t(r[0]) },
        ...ROLES.map((role, i) => ({
          title: t(`role_${role}`),
          align: "center" as const,
          render: (_: unknown, r: [string, Cell[]]) => {
            const c = r[1][i];
            return c === 1 ? <Pill tone="ok">✓</Pill> : c === "own" ? <Pill tone="info">{t("a_ownOnly")}</Pill> : <span style={{ opacity: 0.4 }}>—</span>;
          },
        })),
      ]}
    />
  );
}
